import React from 'react'
import Link from 'next/link'

import { Text } from '@wartek-id/text'
import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Badge } from '@wartek-id/badge'

import {
  CERTIFICATE_STATUS,
  type CertificateStatusType,
} from 'api/microlearning/types'

type CertificateAksiNyataCard = {
  certificateStatus?: CertificateStatusType
  topikId?: string | number
}

const CertificateAksiNyataCard = (props: CertificateAksiNyataCard) => {
  const renderContent = (
    certificateStatus?: CertificateAksiNyataCard['certificateStatus']
  ) => {
    if (
      !certificateStatus ||
      certificateStatus === CERTIFICATE_STATUS.NOT_AVAILABLE
    ) {
      return (
        <div className="flex flex-col gap-3 border border-subdued rounded p-4 bg-white mt-2">
          <Text variant="body-sm" color="subdued">
            Sertifikat sudah tidak tersedia karena tidak ada Aksi Nyata yang
            perlu dikerjakan. Anda cukup menggunakan{' '}
            <strong>Surat Keterangan Selesai Topik</strong> sebagai bukti
            penyelesaian.
          </Text>
        </div>
      )
    }
    if (certificateStatus === CERTIFICATE_STATUS.AVAILABLE) {
      return (
        <div className="flex gap-3 border border-subdued rounded p-4 bg-white mt-2">
          <div
            className={
              'flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden bg-icon-informational'
            }
          >
            <Icon as="i" fontSize="sm" color="inverse">
              download_outlined
            </Icon>
          </div>
          <div className="w-full">
            <Badge className="mb-2">Sertifikat Tersedia</Badge>
            <Text color="subdued" variant="body-sm" data-testid="card-element">
              Unduh sertifikat Anda karena telah menyelesaikan topik ini.
            </Text>

            <Link
              href={`/pelatihan-mandiri/topik/${props.topikId}/sertifikat`}
              passHref
            >
              <Button color="black" fullWidth size="md" className="mt-4">
                Lihat Sertifikat
              </Button>
            </Link>
          </div>
        </div>
      )
    }

    return (
      <div className="flex gap-3 border border-subdued rounded p-4 bg-white mt-2">
        <div
          className={
            'flex justify-center flex-shrink-0 items-center w-8 h-8 rounded-full overflow-hidden bg-icon-disabled'
          }
        >
          <Icon as="i" fontSize="sm" color="inverse">
            download_outlined
          </Icon>
        </div>
        <div className="w-full">
          <Badge className="mb-2">Sertifikat dalam proses</Badge>
          <Text color="subdued" variant="body-sm" data-testid="card-element">
            Begitu selesai diproses, sertifikat Anda akan muncul di sini.
          </Text>
        </div>
      </div>
    )
  }
  return (
    <div className="px-3 my-5">
      <Text variant="heading-md">Sertifikat</Text>

      {renderContent(props.certificateStatus)}
    </div>
  )
}

export default CertificateAksiNyataCard
